import { useState } from 'react';

import ChildrenDialog from './children-dialog';
import Grid from './grid';
import Header from './header';
import Leaderboard from './leaderboard';
import OSMCard from './osm-card';
import OSMDialog from './osm-dialog';

export function Stats(): React.JSX.Element {
  const [osmDialogOpen, openOSMDialog] = useState(false);
  const [childrenDialogOpen, openChildrenDialog] = useState(false);

  return (
    <>
      <Header openChildrenDialog={openChildrenDialog} />
      <Grid />
      <OSMCard openOSMDialog={openOSMDialog} />
      <Leaderboard />
      <OSMDialog onClose={() => openOSMDialog(false)} open={osmDialogOpen} />
      <ChildrenDialog onClose={() => openChildrenDialog(false)} open={childrenDialogOpen} />
    </>
  );
}
